// Signups waiting for approval, as the Artemis banner counts them.
import { apiGet } from "./fetch";

/** Zero for anyone outside the Artemis group: the server decides who sees it. */
export interface PendingRegistrations {
	count: number;
	oldest_date_joined: string | null;
}

/** Fired when a registration is approved or deleted, so the banner recounts. */
export const PENDING_REGISTRATIONS_CHANGED = "pending-registrations-changed";

export const fetchPendingRegistrations = (): Promise<PendingRegistrations> =>
	apiGet(
		"/api/v2/user-management/pending-users/summary/"
	) as Promise<PendingRegistrations>;
